import React from 'react';

const TrendUpIcon = () => {
  return (
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M17.3359 7.58374H23.8359V14.0837'
        stroke='#22B231'
        strokeWidth='2.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M23.8307 7.58293L14.6224 16.7913L9.20573 11.3746L2.16406 18.4163'
        stroke='#22B231'
        strokeWidth='2.16667'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TrendUpIcon;
